import React from "react";
import { dateRange } from "./templateHelpers";
import ExtraResumeSections from "./ExtraResumeSections";

export default function DualBalancedTemplate({ draft, accent }) {
  return (
    <div className="bg-white text-slate-900 rounded-xl p-7 shadow-2xl text-[13px] leading-relaxed" data-testid="resume-live-preview">
      <div className="text-center mb-4">
        <h1 className="text-2xl font-bold">{draft.full_name || "Your Name"}</h1>
        {draft.target_role && <p className="text-sm font-semibold mt-0.5" style={{ color: accent }}>{draft.target_role}</p>}
        <p className="text-slate-500 text-[11px] mt-2">{[draft.contact_email, draft.contact_phone, draft.location].filter(Boolean).join("  •  ")}</p>
      </div>
      {draft.summary && <p className="text-slate-700 mb-4 text-center">{draft.summary}</p>}
      <div className="flex gap-6">
        <div className="w-1/2">
          {draft.experience.length > 0 && (
            <div className="mb-4">
              <h2 className="text-xs font-bold uppercase tracking-wider mb-2" style={{ color: accent }}>Experience</h2>
              {draft.experience.map((e, i) => (
                <div key={i} className="mb-2.5">
                  <p className="font-semibold text-slate-800">{e.title} — {e.company}</p>
                  <p className="text-slate-400 italic text-[11px]">{dateRange(e.start_date, e.end_date, e.current)}</p>
                  <ul className="list-disc list-inside text-slate-700 mt-0.5">{e.bullets.filter(Boolean).map((b, bi) => <li key={bi}>{b}</li>)}</ul>
                </div>
              ))}
            </div>
          )}
        </div>
        <div className="w-1/2">
          {draft.education.length > 0 && (
            <div className="mb-4">
              <h2 className="text-xs font-bold uppercase tracking-wider mb-2" style={{ color: accent }}>Education</h2>
              {draft.education.map((ed, i) => <p key={i} className="text-slate-700 mb-1">{ed.degree} {ed.field} — {ed.school}</p>)}
            </div>
          )}
          {draft.skills.length > 0 && (
            <div className="mb-4">
              <h2 className="text-xs font-bold uppercase tracking-wider mb-2" style={{ color: accent }}>Skills</h2>
              <p className="text-slate-700">{draft.skills.join(", ")}</p>
            </div>
          )}
          <ExtraResumeSections draft={draft} accent={accent} />
        </div>
      </div>
    </div>
  );
}
